var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.exams,"item-text":"title","item-value":"id","deletable-chips":"","small-chips":"","multiple":"","prepend-icon":"mdi-note-text","loading":_vm.loading,"label":_vm.$lang('EXAM')},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }